(function () {
    'use strict';

    function contractorProjectController($scope, $route, $routeParams, $location, $window, $interval, $log, $timeout,
        contractorProjectDataService, workflowConfigurationDataService, workflowProcessingService, sessionDataService,
        mailRequestDataService, notifyService, fileUploadsService, adminMode, STATES_LIST) {

        var self = this;

        this.adminMode = false;
        this.sharedMode = 'NoSharing';
        this.mode = '';
        this.selectedFiles = [];
        this.productQualifications = [];
        this.statesList = STATES_LIST;

        this.convertToInt = function (id) {
            return parseInt(id, 10);
        };

        this.convertToDecimal = function (id) {
            return parseFloat(id);
        };

        $scope.$watch(function () {
            return workflowProcessingService.mode;
        }, function (newValue) {
            if (newValue) {
                self.mode = newValue;
                if (newValue == 'Submit' || newValue == 'Skip') {
                    self.nextPhaseSummary = workflowProcessingService.getNextPhaseSummary(self.Project.Phases, self.CurrentPhaseIndex);
                }
            }
        });

        $scope.$watch(function () { return fileUploadsService.selectedFiles; }, function (newValue) {
            self.selectedFiles = newValue;
        }, true);

        this.getEditorUrl = function (phaseIndex) {
            var baseUrl = (self.adminMode ? '/admin/contractorprojects/update/' : '/entities/projects/review/') + self.Project.FriendlyId;

            return baseUrl + '/' + phaseIndex;
        };

        this.switchPhase = function (phaseIndex) {
            $window.location = self.getEditorUrl(phaseIndex + 1);
        }

        this.getReviewUrl = function () {
            return self.adminMode ? '/admin/contractorprojects/review/' + self.Project.FriendlyId : '/entities/projects/review/' + self.Project.FriendlyId;
        };

        this.phaseHasMarketingMaterials = function(element, index, array) {
            return element.$type === 'Ecap.Api.ViewModels.MarketingMaterialsProjectPhaseExtension, Ecap.Api';
        }

        this.sendProjectReminder = function() {
            mailRequestDataService.sendProjectReminder(this.Project.Id).then(function(data) {
                notifyService.notify('Your project reminder email has been sent');
            });
        }

        this.Project = {};
        this.CurrentPhaseIndex = 1;
        this.nextPhaseSummary = {};
        this.user = {};
        self.accessingEntityId = '';
        this.CurrentProjectExtensionIndex = null;
        this.CurrentProjectExtension = {};
        this.CurrentProjectPhaseExtensionIndex = null;
        this.CurrentProjectPhaseExtension = {};
        this.CurrentPhaseForExtensionIndex = null;
        this.projectOwnerMode = function() {
            return self.accessingEntityId === self.Project.EntityId;
        }

        this.isInternalDetailsExtensionAvailable = function (extension) {
            return self.projectOwnerMode() || (adminMode && extension.AllowAdminAccess);
        }

        this.init = function () {
            $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                sessionDataService.loadSession().then(function (data) {
                    self.user = data.UserName;
                    self.accessingEntityId = data.EntityId;
                    var phaseIndex = toParams.phaseIndex;
                    if (phaseIndex) {
                        self.CurrentPhaseIndex = parseInt(phaseIndex);
                    }
                    workflowProcessingService.adminMode = adminMode;
                    self.adminMode = adminMode;
                    self.loadContractorProject(toParams.contractorProjectId);
                });
            });
        };

        this.delete = function () {
            $window.location = (self.adminMode ? '/admin/contractorprojects/delete/' : '/entities/projects/delete/') + self.Project.FriendlyId;
        };

        this.removeProjectSharingConnection = function (entityId) {
            self.Project.ProjectExtensions.forEach(function(extension) {
                if (extension.$type === 'Ecap.Api.ViewModels.ShareWithPartnersProjectExtensionViewModel, Ecap.Api') {
                    var matchingIndex = extension.ProjectSharingConnections.map(function(connection) {
                        return connection.EntityId;
                    }).indexOf(entityId);

                    if (matchingIndex !== -1) {
                        extension.ProjectSharingConnections.splice(matchingIndex, 1);
                    }
                }
            });
        }

        this.deleteProductQualification = function (container, index) {
            container.splice(index, 1);
        }

        this.hasProductQualifications = function() {
            if (self.Project.Phases) {
                if (_.some(self.Project.ProjectExtensions, {
                    '$type': 'Ecap.Api.ViewModels.ProductSelectionProjectExtensionViewModel, Ecap.Api'
                })) {
                    // OLD CODE to check for specific qualifications
                    //var productSelectionExtension = _.find(self.Project.ProjectExtensions, { '$type': 'Ecap.Api.ViewModels.ProductSelectionProjectExtensionViewModel, Ecap.Api' });

                    //if (productSelectionExtension.ProductQualifications.length >= 0) {
                    //    return true;
                    //}

                    // Just check if the extension is present
                    return true;
                }

                for (var k = 0; k < self.Project.Phases.length; k++) {
                    for (var l = 0; l < self.Project.Phases[k].ProjectPhaseExtensions.length; l++) {
                        if (self.Project.Phases[k].ProjectPhaseExtensions[l].ProductQualifications) {
                            // OLD CODE to check for specific qualifications
                            //if (self.Project.Phases[k].ProjectPhaseExtensions[l].ProductQualifications.length > 0) {
                            //    return true;
                            //}

                            // Just check if the extension is present
                            return true;
                        }
                    }
                }

            }
            return false;
        };

        this.loadContractorProject = function (id) {
            return contractorProjectDataService.loadContractorProject(id).then(function (data) {
                self.Project = data;

                // TODO: This should be mapped on the server side
                var allProjectPhaseExtensions = _.chain(self.Project.Phases).pluck('ProjectPhaseExtensions').flatten().value();
                self.Project.HasPartners = allProjectPhaseExtensions.some(function (element, array, index) {
                    if (element.$type === 'Ecap.Api.ViewModels.FindAPartnerProjectPhaseExtensionViewModel, Ecap.Api') {
                        if (element.PartnerConnections.length > 0) {
                            return true;
                        }
                    }
                    return false;
                });
                self.Project.HasTasks = _.some(self.Project.ProjectExtensions, {
                    'EditorMode': 'ExtensionEditorAndSummaryDisplay'
                });
                self.Project.IsProjectApplication = _.some(self.Project.ProjectExtensions, {
                    '$type': 'Ecap.Api.ViewModels.ApplyForAProjectExtensionViewModel, Ecap.Api'
                });
                self.Project.IsUploadProject = _.some(self.Project.ProjectExtensions, {
                    '$type': 'Ecap.Api.ViewModels.PartnerCriteriaProjectExtensionViewModel, Ecap.Api'
                });
                self.Project.CanShareWithPartners = _.some(self.Project.ProjectExtensions, {
                    '$type': 'Ecap.Api.ViewModels.ShareWithPartnersProjectExtensionViewModel, Ecap.Api'
                });
                self.Project.HasMyTeam = _.some(self.Project.ProjectExtensions, {
                    '$type': 'Ecap.Api.ViewModels.MyTeamProjectExtensionViewModel, Ecap.Api'
                });

                if (self.Project.IsUploadProject) {
                    self.CurrentProjectExtensionIndex = 0;
                    self.CurrentProjectExtension = self.Project.ProjectExtensions[0];
                }

                self.Project.FriendlyId = data.Id.replace('ContractorProjects/', '');
                if (!self.CurrentPhaseIndex) {
                    self.CurrentPhaseIndex = self.Project.CurrentPhaseIndex + 1;
                }

                if (_.some(self.Project.ProjectExtensions, {
                    '$type': 'Ecap.Api.ViewModels.ProductSelectionProjectExtensionViewModel, Ecap.Api'
                })) {
                    var productSelectionExtension = _.find(self.Project.ProjectExtensions, { '$type': 'Ecap.Api.ViewModels.ProductSelectionProjectExtensionViewModel, Ecap.Api' });

                    if (productSelectionExtension.ProductQualifications.length === 0) {
                        var extensionIndex = self.Project.ProjectExtensions.indexOf(productSelectionExtension);
                        self.CurrentProjectExtension = self.Project.ProjectExtensions[extensionIndex];
                        self.mode = "Extension";
                    }
                }


                if (_.some(self.Project.ProjectExtensions, {
                    '$type': 'Ecap.Api.ViewModels.ShareWithPartnersProjectExtensionViewModel, Ecap.Api'
                })) {
                    var shareWithPartnersExtension = _.find(self.Project.ProjectExtensions, { '$type': 'Ecap.Api.ViewModels.ShareWithPartnersProjectExtensionViewModel, Ecap.Api' });

                    self.sharedMode = shareWithPartnersExtension.ProjectSharingConnections.some(function(item) {
                        return item.EntityId === self.accessingEntityId && item.Status === "Active";
                    }) ? "SharingWith" : "NotSharingWith";
                }

                if (!self.adminMode) {
                    if (self.accessingEntityId === self.Project.EntityId) {
                        if (self.Project.LockedForProjectOwner) {
                            workflowProcessingService.mode = "Locked";
                        }
                        else {
                            workflowProcessingService.mode = "Edit";
                            self.Project.Attributes.forEach(function (attribute) {
                                attribute.Mode = 'Editor';
                            });
                            self.Project.AdminAttributes.forEach(function (attribute) {
                                attribute.Mode = 'Display';
                            });
                        }
                    }
                    else {
                        if (self.sharedMode === "NotSharingWith") {
                            workflowProcessingService.mode = "Locked";
                        }
                        else {
                            workflowProcessingService.mode = "Edit";
                            self.Project.Attributes.forEach(function (attribute) {
                                attribute.Mode = 'Display';
                            });
                            self.Project.AdminAttributes.forEach(function (attribute) {
                                attribute.Mode = 'Disblay';
                            });
                        }
                    }
                }
                else {
                    workflowProcessingService.mode = "Edit";
                    self.Project.Attributes.forEach(function (attribute) {
                        attribute.Mode = 'Editor';
                    });
                    self.Project.AdminAttributes.forEach(function (attribute) {
                        attribute.Mode = 'Editor';
                    });
                }

                self.Project.HasInternalDetails = _.some(self.Project.ProjectExtensions, {
                    '$type': 'Ecap.Api.ViewModels.InternalDetailsProjectExtensionViewModel, Ecap.Api'
                });
            });
        };

        this.NextPhaseSummary = undefined;

        this.phaseHasDocuments = function (phase) {
            for (var i = 0; i < phase.InformationParts.length; i++) {
                if (phase.InformationParts[i].DocumentUploads) {
                    return true;
                }
            }
            return false;
        };

        this.isLastPhase = function () {
            if (!self.Project.Phases) {
                return false;
            }
            return self.Project.Phases.length === self.CurrentPhaseIndex;
        };

        this.projectId = function () {
            return self.Project.Id.replace("ContractorProjects/", "");
        };

        this.deleteFile = function (blob, documentUpload) {

            contractorProjectDataService.deleteUploadBlob(blob.BlobReference).then(function (blobDeleteData) {
                documentUpload.BlobSummaries.splice(documentUpload.BlobSummaries.indexOf(blob), 1);

                contractorProjectDataService.saveContractorProject(self.Project.Id, angular.toJson(self.Project)).then(function (saveData) {
                    notifyService.notify('The file \"' + blobDeleteData.deletedFileName + '\" was successfully removed');
                });
            });
        }

        this.toggleLockProjectForOwner = function () {
            self.Project.LockedForProjectOwner = !self.Project.LockedForProjectOwner;
            contractorProjectDataService.saveContractorProject(self.Project.Id, angular.toJson(self.Project)).then(function (saveData) {
                notifyService.notify('The project was successfully ' + (self.Project.LockedForProjectOwner ? 'locked' : 'unlocked') + ' for the project owner');
            });
        }

        //var getNextPhaseSummary = function() {
        //    return (self.Project.CurrentPhaseIndex + 1 < self.Project.Phases.length)
        //        ? {
        //            NextPhaseIndex: self.Project.CurrentPhaseIndex + 1,
        //            NextPhaseTitle: self.Project.Phases[self.Project.CurrentPhaseIndex + 1].Title
        //        }
        //        : undefined;
        //};

        this.unskipPhase = function () {
            var onUnskipComplete = function () {
                contractorProjectDataService.saveContractorProject(self.Project.Id, angular.toJson(self.Project)).then(function (data) {
                });
            };

            workflowProcessingService.unskipPhase(self.Project, self.Project.Phases, self.CurrentPhaseIndex, onUnskipComplete);
        };

        this.submitPhase = function () {
            if ($scope.contractorProjectForm.$valid) {

                if (self.Project.IsUploadProject) {
                    self.Project.ProjectExtensions[self.CurrentProjectExtensionIndex] = self.CurrentProjectExtension;
                }

                var onUploadsComplete = function () {
                    workflowProcessingService.advancePhase(self.Project, self.Project.Phases, self.CurrentPhaseIndex, function () {
                        contractorProjectDataService.saveContractorProject(self.Project.Id, angular.toJson(self.Project)).then(function (data) {
                            $('#myModal').modal('hide');

                            if (self.CurrentPhaseIndex < self.Project.Phases.length) {
                                $window.location = self.getEditorUrl(parseInt(self.CurrentPhaseIndex) + 1);
                            }
                            else {
                                $window.location = self.getEditorUrl(self.CurrentPhaseIndex);
                            }
                        });
                    });
                };

                workflowProcessingService.submitPhase(self.Project.Phases, self.CurrentPhaseIndex, onUploadsComplete);

                $('#myModal').modal('show');

            }
            else {
                alert('invalid form');
            }
        };

        this.skipPhase = function () {
            workflowProcessingService.skipPhase(self.Project, self.Project.Phases, self.CurrentPhaseIndex);

            contractorProjectDataService.saveContractorProject(self.Project.Id, angular.toJson(self.Project)).then(function (data) {
                if (self.CurrentPhaseIndex < self.Project.Phases.length) {
                    $window.location = self.getEditorUrl(parseInt(self.CurrentPhaseIndex) + 1);
                } else {
                    $window.location = self.getEditorUrl(self.CurrentPhaseIndex);
                }
            });

        };

        this.updatePhase = function () {
            if ($scope.contractorProjectForm.$valid) {
                if (self.Project.IsUploadProject) {
                    self.Project.ProjectExtensions[self.CurrentProjectExtensionIndex] = self.CurrentProjectExtension;
                }

                self.Project.CurrentPhaseIndex = self.CurrentPhaseIndex - 1;

                $('#myModal').modal('show');
                var onUploadsComplete = function () {
                    contractorProjectDataService.saveContractorProject(self.Project.Id, angular.toJson(self.Project)).then(function (data) {
                        $('#myModal').modal('hide');
                    });
                };

                workflowProcessingService.updatePhase(onUploadsComplete);
            }
            else {
                alert('invalid form');
            }
        };

        this.editExtension = function (index) {
            self.CurrentProjectExtensionIndex = index;
            self.CurrentProjectExtension = self.Project.ProjectExtensions[index];
            self.mode = "Extension";
        }


        this.saveExtension = function (form) {
            if (form.$valid) {
                self.Project.ProjectExtensions[self.CurrentProjectExtensionIndex] = self.CurrentProjectExtension;
                contractorProjectDataService.saveContractorProject(self.Project.Id, angular.toJson(self.Project)).then(function (data) {
                    notifyService.notify('Your changes have been saved');
                    self.mode = "Edit";
                    self.CurrentProjectExtension = {};
                    self.CurrentProjectExtensionIndex = null;
                });
            }
        }

        this.cancelSaveExtension = function () {
            self.mode = "Edit";
            self.CurrentProjectExtension = {};
            self.CurrentProjectExtensionIndex = null;
        }

        this.clearProjectExtensionForm = function (form, defaultValues) {
            form.$setPristine();
            self.CurrentProjectExtension = {
                $type: self.CurrentProjectExtension.$type,
                Title: self.CurrentProjectExtension.Title,
                Prompt: self.CurrentProjectExtension.Prompt
            };

            for (var attrname in defaultValues) { self.CurrentProjectExtension[attrname] = defaultValues[attrname]; }
        }

        this.editMyTeam = function() {
            var myTeamExtension = self.Project.ProjectExtensions.find(function(item) {
                return item['$type'] === 'Ecap.Api.ViewModels.MyTeamProjectExtensionViewModel, Ecap.Api';
            });

            if (myTeamExtension) {
                var index = self.Project.ProjectExtensions.indexOf(myTeamExtension);
                self.editExtension(index);
            }
            else {
                $log.error('There is no configured my team extension');
            }
        }

        this.logToConsole = function () {
            $log.debug(self.Project);
        }


        this.editPhaseExtension = function (phaseIndex, extensionIndex, phaseType, phaseData) {
            $log.debug('Phase Index:', phaseIndex, 'Extension Index:', extensionIndex);
            self.CurrentProjectPhaseExtensionIndex = extensionIndex;
            self.CurrentPhaseForExtensionIndex = phaseIndex;
            self.CurrentProjectPhaseExtension = self.Project.Phases[self.CurrentPhaseForExtensionIndex].ProjectPhaseExtensions[self.CurrentProjectPhaseExtensionIndex];
            $log.debug(self.CurrentProjectPhaseExtension);
            self.mode = "PhaseExtension";
        }

        this.savePhaseExtension = function (form) {
            if (form.$valid) {
                self.Project.Phases[self.CurrentPhaseForExtensionIndex].ProjectPhaseExtensions[self.CurrentProjectPhaseExtensionIndex] = self.CurrentProjectPhaseExtension;
                contractorProjectDataService.saveContractorProject(self.Project.Id, angular.toJson(self.Project)).then(function (data) {
                    notifyService.notify('Your changes have been saved');
                    self.mode = "Edit";
                    self.CurrentProjectPhaseExtension = {};
                    self.CurrentProjectPhaseExtensionIndex = null;
                    self.CurrentPhaseForExtensionIndex = null;
                });
            }
        }

        this.cancelSavePhaseExtension = function () {
            self.mode = "Edit";
            self.CurrentProjectPhaseExtension = {};
            self.CurrentProjectPhaseExtensionIndex = null;
        }

        this.setProductQualifications = function () {
            if (self.mode === "Extension") {

                for (var i = 0; i < self.CurrentProjectExtension.ProductGroups.length; i++) {
                    for (var j = 0; j < self.CurrentProjectExtension.ProductGroups[i].ProductDefinitions.length; j++) {
                        if (self.CurrentProjectExtension.ProductGroups[i].ProductDefinitions[j].isSelected) {
                            if (!self.CurrentProjectExtension.ProductQualifications.some(function(element) {
                                return element.ProductId === self.CurrentProjectExtension.ProductGroups[i].ProductDefinitions[j].Id;
                            })) {
                                self.CurrentProjectExtension.ProductQualifications.push({
                                    ProductId: self.CurrentProjectExtension.ProductGroups[i].ProductDefinitions[j].Id,
                                    Product: self.CurrentProjectExtension.ProductGroups[i].ProductDefinitions[j],
                                    Status: 'CompletingApplication'
                                });
                            }
                        }
                    }
                }
                self.Project.ProjectExtensions[self.CurrentProjectExtensionIndex] = self.CurrentProjectExtension;

            }
            else if (self.mode === "PhaseExtension") {
                for (var i = 0; i < self.CurrentProjectPhaseExtension.ProductGroups.length; i++) {
                    for (var j = 0; j < self.CurrentProjectPhaseExtension.ProductGroups[i].ProductDefinitions.length; j++) {
                        if (self.CurrentProjectPhaseExtension.ProductGroups[i].ProductDefinitions[j].isSelected) {
                            if (!self.CurrentProjectPhaseExtension.ProductQualifications.some(function(element) {
                                return element.ProductId === self.CurrentProjectPhaseExtension.ProductGroups[i].ProductDefinitions[j].Id;
                            })) {
                                self.CurrentProjectPhaseExtension.ProductQualifications.push({
                                    ProductId: self.CurrentProjectPhaseExtension.ProductGroups[i].ProductDefinitions[j].Id,
                                    Product: self.CurrentProjectPhaseExtension.ProductGroups[i].ProductDefinitions[j],
                                    Status: 'CompletingApplication'
                                });
                            }
                        }
                    }
                }
                self.Project.Phases[self.CurrentPhaseForExtensionIndex].ProjectPhaseExtensions[self.CurrentProjectPhaseExtensionIndex] = self.CurrentProjectPhaseExtension;
            }

            contractorProjectDataService.saveContractorProject(self.Project.Id, angular.toJson(self.Project)).then(function (data) {
                notifyService.notify('Your changes have been saved');
                self.mode = "Edit";
                self.CurrentProjectPhaseExtension = {};
                self.CurrentProjectPhaseExtensionIndex = null;
            });
        }


        this.init();
    }

    contractorProjectController.$inject = ['$scope', '$route', '$routeParams', '$location', '$window', '$interval', '$log', '$timeout',
    'contractorProjectDataService', 'workflowConfigurationDataService', 'workflowProcessingService', 'sessionDataService',
    'mailRequestDataService', 'notifyService', 'fileUploadsService', 'adminMode', 'STATES_LIST'];

    angular.module('ecap.workflow').controller('contractorProjectController', contractorProjectController);
})();
